/*
 * ShiftDetailCardRoutes Messages
 *
 * This contains all the text for the ShiftDetailCardRoutes component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.ShiftDetailCardRoutes.header',
    defaultMessage: 'Routes',
  },
  currentlyPlanned: {
    id: 'app.components.ShiftDetailCardRoutes.currentlyPlanned',
    defaultMessage: '{plannedTurns} routes currently planned',
  },
  planRoutes: {
    id: 'app.components.ShiftDetailCardRoutes.planRoutes',
    defaultMessage: 'Plan Routes',
  },
  noApplications: {
    id: 'app.components.ShiftDetailCardRoutes.noApplications',
    defaultMessage: 'There are no applications for this shift, yet.',
  },
});
